import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Alert, Empty, Pagination, Spin } from "antd";
import { useDevice } from "../../hooks";
import axiosInstance from "../../utils/axios";
import ItemProductGrid from "../../section/itemProductGrid";

export default function SearchPage() {
  const { isMobile } = useDevice();
  const { keyword = "" } = useParams();
  const [page, setPage] = useState(1);
  const [product, setProduct] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const pageSize = 12;

  useEffect(() => { setPage(1); }, [keyword]);

  useEffect(() => {
    let active = true;
    async function load() {
      setLoading(true);
      setError(false);
      try {
        const res = await axiosInstance.get("/search-page/getAllSearchPage", {
          params: { keyword, page, pageSize }
        });
        if (!active) return;
        setProduct(Array.isArray(res?.data?.data) ? res.data.data : []);
        setTotal(Number(res?.data?.total) || 0);
      } catch (err) {
        if (!active) return;
        setProduct([]);
        setTotal(0);
        setError(true);
      } finally {
        if (active) setLoading(false);
      }
    }
    load();
    return () => { active = false; };
  }, [keyword, page]);

  return (
    <div className="max-w-screen-2xl mx-auto">
      <div className={`${isMobile ? "mt-14" : "mt-5"} p-5 bg-white`}>
        <h1 className="text-xl">Kết quả tìm kiếm: <span className="font-semibold">{keyword}</span></h1>
        {!loading && !error && <p className="text-gray-500 mt-2">Tìm thấy {total} sản phẩm</p>}
      </div>
      <div className="my-2 p-5 bg-white min-h-[260px]">
        {loading ? (
          <div className="flex justify-center py-16"><Spin size="large" /></div>
        ) : error ? (
          <Alert type="error" showIcon message="Không tải được kết quả tìm kiếm" description="Vui lòng thử lại sau." />
        ) : product.length ? (
          <>
            <ItemProductGrid product={product} grid={isMobile ? 2 : 5} titleSize={13} heightTitle={10} />
            {total > pageSize && (
              <div className="flex justify-center mt-8">
                <Pagination current={page} pageSize={pageSize} total={total} showSizeChanger={false}
                  onChange={(next) => { setPage(next); window.scrollTo({ top: 0, behavior: "smooth" }); }} />
              </div>
            )}
          </>
        ) : <Empty description="Không tìm thấy sách phù hợp" />}
      </div>
    </div>
  );
}
